import $ from "jquery";
import getOffsetRect from "./getOffsetRect.js";


export default function ExpertsAlphabetAnchors(container) {
    let isFixed = "";
    const containerHeight = container.clientHeight;
    let containerOffsetTop = getOffsetRect(container).top;
    let containerOffsetLeft = getOffsetRect(container).left;

    const body = document.getElementById("experts-alphabet-anchors-body");
    const bodyStyle = body.style;
    const bodyBaseClass = body.getAttribute("data-base-class");
    const bodyHeight = body.clientHeight;

    let documentScrollTop = document.documentElement.scrollTop;

    $(".js-expert-anchor-link").on("click", function(e) {
        e.preventDefault();
        $(".js-expert-anchor-link").removeClass("is-active");
        $(this).addClass("is-active");
        $("html, body").animate({
            scrollTop: $(this.hash).offset().top - 65
        }, 800);
    });


    window.addEventListener("load", function() {
        documentScrollTop = document.documentElement.scrollTop;
        checkBodyPosition();
    });

    window.addEventListener("scroll", function() {
        documentScrollTop = document.documentElement.scrollTop;
        checkBodyPosition();
    });


    function checkBodyPosition() {
        if ( (documentScrollTop + 60) > containerOffsetTop ) {
            if ( (documentScrollTop + 60 + bodyHeight) < (containerOffsetTop + containerHeight) ) {
                if (isFixed != "top") {
                    body.classList.add(bodyBaseClass + "_fixed-top");
                    body.classList.remove(bodyBaseClass + "_fixed-bottom");
                    bodyStyle.left = containerOffsetLeft + "px";
                    isFixed = "top";
                }
            } else {
                if (isFixed != "bottom") {
                    body.classList.remove(bodyBaseClass + "_fixed-top");
                    body.classList.add(bodyBaseClass + "_fixed-bottom");
                    bodyStyle.left = "";
                    isFixed = "bottom";
                }
            }
        } else {
            body.classList.remove(bodyBaseClass + "_fixed-top");
            body.classList.remove(bodyBaseClass + "_fixed-bottom");
            bodyStyle.left = "";
            isFixed = "";
        }
    }
}